import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { whatsUrl: String, marcarUrl: String }

  enviar(event) {
    event.preventDefault()

    window.open(this.whatsUrlValue, "_blank")

    fetch(this.marcarUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "text/vnd.turbo-stream.html"
      }
    }).then(r => r.text()).then(html => {
      Turbo.renderStreamMessage(html)
    })
  }
}
